var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Row, Col, Button, AccordionSet, Accordion, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { CoEditionRequestStatus, } from "../../types/Api";
var getCoPublisherDecisionKey = function (request) {
    if (request.status === CoEditionRequestStatus.DECLINED_BY_CO_PUBLISHER) {
        return "declined";
    }
    return request.coPublisherConfirmedByAgency
        ? "confirmedByAgency"
        : "approved";
};
var CoEditionRequestDetail = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var request = _a.request, onGoToProduct = _a.onGoToProduct;
    var _l = useIntl(), formatMessage = _l.formatMessage, formatDate = _l.formatDate;
    var _m = useState({
        request: true,
        product: true,
    }), accordionStatus = _m[0], setAccordionStatus = _m[1];
    var _o = useState(true), expandAll = _o[0], setExpandAll = _o[1];
    var renderField = function (label, value) { return (React.createElement(Row, { style: { marginBottom: "25px" } },
        React.createElement(Col, { xs: 12 },
            React.createElement("div", { style: { marginBottom: "5px" } },
                React.createElement("strong", { style: { fontSize: "1.1em", paddingRight: "5px" } }, label)),
            React.createElement("div", null, value || "N/A")))); };
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[section] = !prevState[section], _a)));
        });
    };
    var toggleExpandCollapseAll = function () {
        setAccordionStatus({
            request: !expandAll,
            product: !expandAll,
        });
        setExpandAll(!expandAll);
    };
    var assignedNumber = ((_b = request.productNumber) === null || _b === void 0 ? void 0 : _b.fullFormattedValue) ||
        ((_c = request.productNumber) === null || _c === void 0 ? void 0 : _c.formattedValue) ||
        ((_d = request.productNumber) === null || _d === void 0 ? void 0 : _d.value);
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.detail.pane.title" })),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, style: { display: "flex", justifyContent: "flex-end" } },
                React.createElement(Button, { onClick: toggleExpandCollapseAll, buttonStyle: "default" }, expandAll
                    ? formatMessage({ id: "ui-br-agency.button.collapse" })
                    : formatMessage({ id: "ui-br-agency.button.expand" })))),
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { id: "request-info", label: formatMessage({
                    id: "ui-br-agency.co-edition.detail.accordion.request",
                }), open: accordionStatus.request, onToggle: function () { return toggleAccordion("request"); } },
                renderField(formatMessage({
                    id: "ui-br-agency.co-edition.detail.field.status",
                }), request.status
                    ? formatMessage({
                        id: "ui-br-agency.co-edition.status.".concat(request.status),
                    })
                    : undefined),
                renderField(formatMessage({
                    id: "ui-br-agency.co-edition.detail.field.dateCreated",
                }), request.dateCreated ? formatDate(request.dateCreated) : undefined),
                renderField(formatMessage({
                    id: "ui-br-agency.co-edition.detail.field.requestedBy",
                }), request.requestedBy),
                renderField(formatMessage({ id: "ui-br-agency.co-edition.detail.field.note" }), request.note),
                request.status === CoEditionRequestStatus.REJECTED &&
                    renderField(formatMessage({
                        id: "ui-br-agency.co-edition.detail.field.rejectionReason",
                    }), request.rejectionReason),
                request.coPublisherDecidedAt && (React.createElement(React.Fragment, null,
                    renderField(formatMessage({
                        id: "ui-br-agency.co-edition.detail.field.coPublisherDecision",
                    }), formatMessage({
                        id: "ui-br-agency.co-edition.detail.coPublisherDecision.".concat(getCoPublisherDecisionKey(request)),
                    })),
                    renderField(formatMessage({
                        id: "ui-br-agency.co-edition.detail.field.coPublisherDecidedAt",
                    }), formatDate(request.coPublisherDecidedAt)),
                    renderField(formatMessage({
                        id: "ui-br-agency.co-edition.detail.field.coPublisherDecidedBy",
                    }), request.coPublisherDecidedBy),
                    renderField(formatMessage({
                        id: "ui-br-agency.co-edition.detail.field.coPublisherDecisionNote",
                    }), request.coPublisherDecisionNote))),
                renderField(formatMessage({
                    id: "ui-br-agency.co-edition.detail.field.dateUpdated",
                }), request.dateUpdated ? formatDate(request.dateUpdated) : undefined)),
            React.createElement(Accordion, { id: "product-info", label: formatMessage({
                    id: "ui-br-agency.co-edition.detail.accordion.product",
                }), open: accordionStatus.product, onToggle: function () { return toggleAccordion("product"); } },
                renderField(formatMessage({ id: "ui-br-agency.co-edition.detail.field.title" }), (_h = (_g = (_f = (_e = request.product) === null || _e === void 0 ? void 0 : _e.title) === null || _f === void 0 ? void 0 : _f.names) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.name),
                renderField(formatMessage({
                    id: "ui-br-agency.co-edition.detail.field.coPublisher",
                }), (_j = request.coPublisher) === null || _j === void 0 ? void 0 : _j.name),
                assignedNumber &&
                    renderField(formatMessage({
                        id: "ui-br-agency.co-edition.detail.field.productNumber",
                    }), assignedNumber),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Button, { buttonStyle: "default", onClick: onGoToProduct, disabled: !((_k = request.product) === null || _k === void 0 ? void 0 : _k.id) },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.detail.goToProduct" }))))))));
};
export default CoEditionRequestDetail;
